import { Component, OnInit, EventEmitter, Inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { GeneralService } from '../services/general.service';
import { ProvidersService } from '../services/providers.service';
import * as decode from 'jwt-decode';

const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

@Component({
  selector: 'app-modal-upload',
  templateUrl: './modal-upload.component.html',
  styleUrls: ['./modal-upload.component.scss']
})
export class ModalUploadComponent implements OnInit {
  type: any;
  info: any;
  loadBtn = false;
  userToken: any;
  userId: any;
  dataForeign: any = {};
  private base64textString: String = '';
  base64Pdf: string;
  filesUpload = 0;
  filesArr = [];
  cpCompany: any;
  diatanceCdfi: any;
  alertDistance = false;
  filesCountUpload = 0;
  showDrop = true;
  step = 1;
  language = 'es';
  msgResp: any;
  txtHead = 'BUTTONS.ADDINVOICE';
  totalSelect: any;
  msgTotal = "El subtotal no coincide con el subtotal seleccionado";
  uploader: FileUploader = new FileUploader({
    url: URL,
    isHTML5: true
  });
  Porcentaje = false;
  Tolerancia = 0;
  Tol = 0;
  Diff = 0;

  hasBaseDropZoneOver = false;


  constructor(public dialog: MatDialog, private toastr: ToastrService, private gralService: GeneralService, private provService: ProvidersService, public translate: TranslateService, private adapter: DateAdapter<any>, public dialogRef: MatDialogRef<ModalUploadComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.userToken = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;
    this.totalSelect = this.data.totalSelect;
    this.type = this.data.type;
    this.info = this.data.data;
    this.language = this.data.data.language;
    this.msgTotal = "El subtotal no coincide con el subtotal seleccionado";
    if (this.language == "en") {
      this.msgTotal = "The subtotal does not match the selected subtotal";
    }
    if (this.data.data) {
      if (this.data.data.datosOrdenCompra) {
        if (this.data.data.datosOrdenCompra.listaRecepcionesDisponibles) {
          for (let selected of this.data.data.datosOrdenCompra.listaRecepcionesDisponibles) {
            this.Porcentaje = selected.ToleranciaPorPorcentaje;
            this.Tolerancia = selected.ToleranciaProveedor;
          }
        }
      }
    }



    if (this.type == 'complement') {
      this.txtHead = 'BUTTONS.ADDCOMPLEMENT';
    }
    console.log(" txthead " + this.language);
  }

  ngOnInit() {
  }

  upp(evt) {
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    this.fileUpload(file);
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  dropped(e) {
    for (let g = 0; g < e.length; g++) {
      this.fileUpload(e[g]);
    }
  }

  fileUpload(file) {
    if (this.type == 'foreign') {
      this.filesCountUpload = 1;
    }
    const exist = this.filesArr.find(x => x.name == file.name);
    if (exist) {
      let title = "Error al cargar archivo";
      let body = 'El archivo ' + file.name + ' ya esta en la lista.';
      if (this.translate.currentLang == "en") {
        title = "Error uploading file";
        body = 'The file ' + file.name + ' is already in the list.';
      } else if (this.translate.currentLang == "es") {
        title = "Error al cargar archivo";
        body = 'El archivo ' + file.name + ' ya esta en la lista.';
      }
      this.toastr.success(title, body);
      this.toastr.error(body, title);
      return false;
    }

    const pattern = /image-*/;
    const patternPdf = /pdf/;
    const patternXml = /xml/;

    if (this.filesCountUpload < 2) {
      if (!file.type.match(patternPdf)) {
        if (!file.type.match(patternXml)) {
          let title = "Error al cargar archivo";
          let body = 'File ' + file.name + ' has invalid file format, only pdf and xml are accepted';
          if (this.translate.currentLang == "en") {
            title = "Error uploading file";
            body = 'El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta pdf y xml.';
          } else if (this.translate.currentLang == "es") {
            title = "Error al cargar archivo";
            body = 'El archivo ' + file.name + ' tiene formato de archivo inválido, solo se acepta pdf y xml.';
          }
          this.toastr.error(body,title);
          return false;
        } else {
          this.filesArr.push({ file: file, name: file.name, size: file.size, color: 'green', type: 'xml', date: '11-07-2018', error: null, id: 13, url: null });
        }
      } else {
        this.filesArr.push({ file: file, name: file.name, size: file.size, color: 'green', type: 'pdf', date: null, error: null, id: null, url: 'http://concent.com.mx' });
      }

      this.filesCountUpload++;
      if (this.filesCountUpload >= 2) {
        this.showDrop = false;
      }
    }
  }

  _loadxml(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.info.xmlBase64 = btoa(binaryString);
  }


  _loadPdf(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64Pdf = btoa(binaryString);
    this.info.pdfBase64 = btoa(binaryString);
  }

  deleteFile(idx) {
    this.filesArr.splice(idx, 1);
    this.filesCountUpload--;
    if (this.filesCountUpload < 2) {
      this.showDrop = true;
    }
  }

  upload() {
    if (this.filesArr.length == 0) {
      let title = "Favor de agregar la factura";
      let body = "Error al crargar archivo";
      if (this.translate.currentLang == "en") {
        title = "Please add the invoice";
        body = "Error uploading file";
      } else if (this.translate.currentLang == "es") {
        title = "Favor de agregar la factura";
        body = "Error al crargar archivo";
      }
      this.toastr.error(title, body);
      return false;
    }

    this.loadBtn = true;
    let existXml = false;

    for (let g = 0; g < this.filesArr.length; g++) {
      if (this.filesArr[g].type == 'xml') {
        const reader = new FileReader();
        reader.onload = this._loadxml.bind(this);
        reader.readAsBinaryString(this.filesArr[g].file);
        existXml = true;
      }

      if (this.filesArr[g].type == 'pdf') {
        const reader = new FileReader();
        reader.onload = this._loadPdf.bind(this);
        reader.readAsBinaryString(this.filesArr[g].file);
      }
    }
    setTimeout(() => {
      if (this.type == 'foreignConsignments') {
        if (!this.dataForeign.serie || !this.dataForeign.folio || !this.dataForeign.rfcEmisor || !this.dataForeign.fechaEmision || !this.dataForeign.rfcReceptor || !this.dataForeign.subTotal) {
          this.toastr.error('Favor de agregar los datos obligatorios', 'Error al crargar archivo');
          this.loadBtn = false;
          return false;
        }
        let tolerancia = 0;
        this.Tol = this.Tolerancia;
        if (this.Porcentaje) {
          this.Tol = (this.dataForeign.subTotal) / (this.Tolerancia);
        }
        this.Diff = this.dataForeign.subTotal - this.totalSelect;
        if (this.Diff < 0) {
          this.Diff = this.Diff * -1;
        }
        if (this.Diff > this.Tol) {
          console.log(" msg " + this.msgTotal);
          this.toastr.error(this.msgTotal);
          this.loadBtn = false;
          return false;
        }

        this.info.xmlBase64 = undefined;
        this.info.facturaPdf = this.dataForeign;

        this.provService.uploadPdfForeign(this.info, this.userToken).then((data) => {
          this.loadBtn = false;

          let msgs = '';
          let body = "La factura ya fue registrada anteriormente. Verifique la información.";
          if (this.translate.currentLang == "en") {
            body = "The invoice has already been registered previously. Check the information.";
          } else if (this.translate.currentLang == "es") {
            body = "La factura ya fue registrada anteriormente. Verifique la información.";
          }
          for (let g = 0; g < data['listaMensajes'].length; g++) {
            if (this.translate.currentLang == "en") {
              if (data['listaMensajes'][g] == "La factura ya fue registrada anteriormente. Verifique la información.") {
                data['listaMensajes'][g] = body;
              } else {
                if (data['listaMensajes'][g].includes("El UUID es")) {
                  break;
                }
              }
            } else {
              if (data['listaMensajes'][g] == "La factura ya fue registrada anteriormente. Verifique la información.") {
                data['listaMensajes'][g] = body;
              }
              else {
                if (data['listaMensajes'][g].includes("El UUID es")) {
                  break;
                }
              }
            }
            msgs = msgs + '<br>- ' + data['listaMensajes'][g];
          }
          this.msgResp = msgs;

          if (data['resultado']) {
            let title = "Archivo correcto";
            let body = "Cargar archivo";
            if (this.translate.currentLang == "en") {
              title = "correct file";
              body = "uploading file";
            } else if (this.translate.currentLang == "es") {
              title = "Archivo correcto";
              body = "Cargar archivo";
            }
            this.toastr.success(title, body);
            this.step = 2;
          } else {
            let title = "Cargar archivo";
            let body = "Error al cargar archivo";
            if (this.translate.currentLang == "en") {
              title = "File upload";
              body = "Error uploading file";
            } else if (this.translate.currentLang == "es") {
              title = "Cargar archivo";
              body = "Error al cargar archivo";
            }
            this.toastr.error(body, title);
            return;
          }
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          let title = "Cargar archivo";
          let body = "Error al cargar archivo";
          if (this.translate.currentLang == "en") {
            title = "File upload";
            body = "Error uploading file";
          } else if (this.translate.currentLang == "es") {
            title = "Cargar archivo";
            body = "Error al cargar archivo";
          }
          this.toastr.error(body, title);
          if (err.status == 401) {
            this.gralService.actDeacUser(false);
          }
        });


      }

      if (this.type == 'foreign') {
        if (
          //!this.dataForeign.serie ||
          //!this.dataForeign.folio ||
          //!this.dataForeign.moneda ||
          !this.dataForeign.fechaEmision ||
          //!this.dataForeign.rfcReceptor ||
          !this.dataForeign.subTotal) {
          let title = "Favor de agregar los datos obligatorios";
          let body = "Please add the required information";
          if (this.translate.currentLang == "en") {
            title = "Please add the required information";
            body = "Error uploading file";
          } else if (this.translate.currentLang == "es") {
            title = "Favor de agregar los datos obligatorios";
            body = "Error al crargar archivo";
          }
          this.toastr.error(title, body);
          this.loadBtn = false;
          return false;
        }
        this.Tol = this.Tolerancia;
        if (this.Porcentaje) {
          this.Tol = (this.dataForeign.subTotal) / (this.Tolerancia);
        }
        this.Diff = this.dataForeign.subTotal - this.totalSelect;
        if (this.Diff < 0) {
          this.Diff = this.Diff * -1;
        }
        if (this.Diff > this.Tol) {
          console.log(" msg " + this.msgTotal);
          this.toastr.error(this.msgTotal);
          this.loadBtn = false;
          return false;
        }
        this.info.xmlBase64 = undefined;
        this.info.facturaExtranjeros = this.dataForeign;

        this.provService.uploadPdfForeign(this.info, this.userToken).then((data) => {
          this.loadBtn = false;
          console.log(data);
          let msgs = '';
          for (let g = 0; g < data['listaMensajes'].length; g++) {
            if (g != 2) {
              msgs = msgs + '<br>- ' + data['listaMensajes'][g];
            }
          }
          this.msgResp = msgs;

          if (data['resultado']) {
            let title = "Archivo correcto";
            let body = "Cargar archivo";
            if (this.translate.currentLang == "en") {
              title = "correct file";
              body = "uploading file";
            } else if (this.translate.currentLang == "es") {
              title = "Archivo correcto";
              body = "Cargar archivo";
            }
            this.toastr.success(title, body);
            this.step = 2;
          } else {
            if (this.filesArr.length == 0) {
              let title = "Favor de agregar la factura";
              let body = "Error al crargar archivo";
              if (this.translate.currentLang == "en") {
                title = "Please add the invoice";
                body = "Error uploading file";
              } else if (this.translate.currentLang == "es") {
                title = "Favor de agregar la factura";
                body = "Error al crargar archivo";
              }
              this.toastr.error(title, body);
              return false;
            }
            return;
          }
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          if (this.filesArr.length == 0) {
            let title = "Favor de agregar la factura";
            let body = "Error al crargar archivo";
            if (this.translate.currentLang == "en") {
              title = "Please add the invoice";
              body = "Error uploading file";
            } else if (this.translate.currentLang == "es") {
              title = "Favor de agregar la factura";
              body = "Error al crargar archivo";
            }
            this.toastr.error(title, body);
            return false;
          }
          if (err.status == 401) {
            this.gralService.actDeacUser(false);
          }
        });
      } else {
        if (!existXml) {
          this.loadBtn = false;
          this.toastr.error('Favor de agregar el archivo XML', 'Error al cargar archivo');
          return false;
        }

        if (this.type == 'consignments') {
          this.info.IdUsuarioSeleccion = this.userId;
          this.provService.uploadCfdiConsignment(this.info, this.userToken).then((data) => {
            this.loadBtn = false;
            console.log(data);
            let msgs = '';
            msgs = data['message']['msg'];
            this.msgResp = msgs;

            if (data['resultado']) {
              let title = "Archivo correcto";
              let body = "Cargar archivo";
              if (this.translate.currentLang == "en") {
                title = "correct file";
                body = "uploading file";
              } else if (this.translate.currentLang == "es") {
                title = "Archivo correcto";
                body = "Cargar archivo";
              }
              this.toastr.success(title, body);
              this.step = 2;
            } else {
              this.toastr.error(msgs, 'Cargar archivo');
              return;
            }
          }, (err) => {
            console.log(err.error);
            this.loadBtn = false;
            this.toastr.error(err.error.message.msg, 'Cargar archivo');
            if (err.status == 401) {
              this.gralService.actDeacUser(false);
            }
          });
        } else if (this.type == 'complement') {
          this.info.IdUsuarioSeleccion = this.userId;  //??????'
          this.provService.uploadCfdiComplement(this.info, this.userToken).then((data) => {
            this.loadBtn = false;
            let msgs = '';
            let body = "La factura ya fue registrada anteriormente. Verifique la información.";
            if (this.translate.currentLang == "en") {
              body = "The invoice has already been registered previously. Check the information.";
            } else if (this.translate.currentLang == "es") {
              body = "La factura ya fue registrada anteriormente. Verifique la información.";
            }
            for (let g = 0; g < data['listaMensajes'].length; g++) {
              if (this.translate.currentLang == "en") {
                if (data['listaMensajes'][g] == "La factura ya fue registrada anteriormente. Verifique la información.") {
                  data['listaMensajes'][g] = body;
                } else {
                  if (data['listaMensajes'][g].includes("El UUID es")) {
                    break;
                  }
                }
              } else {
                if (data['listaMensajes'][g] == "La factura ya fue registrada anteriormente. Verifique la información.") {
                  data['listaMensajes'][g] = body;
                }
                else {
                  if (data['listaMensajes'][g].includes("El UUID es")) {
                    break;
                  }
                }
              }
              msgs = msgs + '<br>- ' + data['listaMensajes'][g];
            }
            this.msgResp = msgs;

            if (data['resultado']) {
              this.toastr.success('Archivo correcto', 'Cargar archivo');
              this.step = 2;
            } else {
              if (this.filesArr.length == 0) {
                let title = "Favor de agregar la factura";
                let body = "Error al crargar archivo";
                if (this.translate.currentLang == "en") {
                  title = "Please add the invoice";
                  body = "Error uploading file";
                } else if (this.translate.currentLang == "es") {
                  title = "Favor de agregar la factura";
                  body = "Error al crargar archivo";
                }
                this.toastr.error(title, body);
                return false;
              }
              return;
            }
          }, (err) => {
            console.log(err);
            this.loadBtn = false;
            if (this.filesArr.length == 0) {
              let title = "Favor de agregar la factura";
              let body = "Error al crargar archivo";
              if (this.translate.currentLang == "en") {
                title = "Please add the invoice";
                body = "Error uploading file";
              } else if (this.translate.currentLang == "es") {
                title = "Favor de agregar la factura";
                body = "Error al crargar archivo";
              }
              this.toastr.error(title, body);
              return false;
            }
            if (err.status == 401) {
              this.gralService.actDeacUser(false);
            }
          });
        } else {
          this.provService.uploadCfdi(this.info, this.userToken).then((data) => {
            this.loadBtn = false;
            console.log(data);
            let msgs = '';
            let body = "La factura ya fue registrada anteriormente. Verifique la información.";
            if (this.translate.currentLang == "en") {
              body = "The invoice has already been registered previously. Check the information.";
            } else if (this.translate.currentLang == "es") {
              body = "La factura ya fue registrada anteriormente. Verifique la información.";
            }
            for (let g = 0; g < data['listaMensajes'].length; g++) {
              if (this.translate.currentLang == "en") {
                if(data['listaMensajes'][g] == "La información se guardó"){
                  msgs = msgs + ' <br>- The information was saved';
                }
                if(data['listaMensajes'][g] == "El CFDI no se pudo procesar."){
                  msgs = msgs + ' <br>- The CFDI could not be processed.';
                }
                if(data['listaMensajes'][g] == "Error: El rfc del proveedor no corresponde al rfc del emisor"){
                  msgs = msgs + ' <br>- Error: The providers RFC does not correspond to the issuers RFC';
                }
                if(data['listaMensajes'][g] == "Error: La factura corresponde a un año diferente al año actual"){
                  msgs = msgs + ' <br>- Error: The invoice corresponds to a different year than the current year';
                }

              }else{
                msgs = msgs + '<br>- ' + data['listaMensajes'][g];
              }
               
              
            }
            this.msgResp = msgs;

            if (data['resultado']) {
              this.toastr.success('Archivo correcto', 'Cargar archivo');
              this.step = 2;
            } else {
              if (this.filesArr.length == 0) {
                let title = "Favor de agregar la factura";
                let body = "Error al crargar archivo";
                if (this.translate.currentLang == "en") {
                  title = "Please add the invoice";
                  body = "Error uploading file";
                } else if (this.translate.currentLang == "es") {
                  title = "Favor de agregar la factura";
                  body = "Error al crargar archivo";
                }
                this.toastr.error(title, body);
                return false;
              }
              return;
            }
          }, (err) => {
            console.log(err);
            this.loadBtn = false;
            if (this.filesArr.length == 0) {
              let title = "Favor de agregar la factura";
              let body = "Error al crargar archivo";
              if (this.translate.currentLang == "en") {
                title = "Please add the invoice";
                body = "Error uploading file";
              } else if (this.translate.currentLang == "es") {
                title = "Favor de agregar la factura";
                body = "Error al crargar archivo";
              }
              this.toastr.error(title, body);
              return false;
            }
            if (err.status == 401) {
              this.gralService.actDeacUser(false);
            }
          });
        }
      }

    }, 1000);
  }

  /*addExpense(data, file){
    data.company = localStorage.getItem('lksd872mc092rjkwe92387kjerhkewhr');
    data.office = localStorage.getItem('gamsdfodg870sdg8wndkdgkskh8rfksl');

    this.expenseService.saveExpense(data, this.userId, this.userToken).then(resp => {
      this.gralService.showloading(false);
      file.id = resp['msg'].id;
      file.date = resp['msg'].date;
    }, (err) => {
      console.log(err.error);
      file.color = 'red';
      file.type = 'Error';
      file.error = 'Error al crear el gasto';
      if(err.error.msg){
        file.error = err.error.msg;
      }else{
        file.error = err.error.message;
      }
      console.log(file.error);
      this.gralService.showloading(false);
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }*/





  onCloseCancel() {
    this.dialogRef.close();
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

}
